import React from "react";
import { Grid } from "@mui/material";
import ProjectCard from "../components/ProjectCard";

function ProjectContainer(props) {
  const { projects } = props;
  return (
    <>
      <Grid container spacing={5}>
        {projects.map((projectItem) => (
          <Grid key={projectItem.id} item xs={12}>
            <ProjectCard item={projectItem} />
          </Grid>
        ))}
      </Grid>
    </>
  );
}

export default ProjectContainer;
